/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Table_NoteInputs */

const en_pc_alt_table_note = /** @type {(inputs: Pc_Alt_Table_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDFCraftTool/pdfcraft is listed because it shares PdfCraft's name, not because the projects are related. It is made by a different team.`)
};

const zh_pc_alt_table_note = /** @type {(inputs: Pc_Alt_Table_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`列出 PDFCraftTool/pdfcraft 是因为它与 PdfCraft 名称相近，而不是因为两个项目有关联。它由另一支团队开发。`)
};

/**
* | output |
* | --- |
* | "PDFCraftTool/pdfcraft is listed because it shares PdfCraft's name, not because the projects are related. It is made by a different team." |
*
* @param {Pc_Alt_Table_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_table_note = /** @type {((inputs?: Pc_Alt_Table_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Table_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_table_note(inputs)
	return zh_pc_alt_table_note(inputs)
});
export { pc_alt_table_note as "pc.alt.table_note" }